import { createRouter, createWebHashHistory } from "vue-router";
import HomeViue from "../views/HomeViue";
import MapDormitory from "../components/MapDormitory/MapDormitory.vue";
const routes = [
  {
    path: "/",
    name: "HomeViue",
    component: HomeViue,
  },
  {
    path: "/MapDormitory",
    name: "MapDormitory",
    component: MapDormitory,
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;
